if ($(".article__featured--look").length && window.location.search) {
  const backHref = window.location.search.replace("?back=", "");
  const $featuredArticle = $(".article__featured");
  $featuredArticle.find(".back .back__link").attr("href", backHref);
  $featuredArticle.find(".next-article a, .prev-article").each(function() {
    $(this).attr("href", $featuredArticle.find(".next-article a").attr("href") + window.location.search);
  });
}



// WEBPACK FOOTER //
// ../assets/js/look-article.js